import { render, staticRenderFns } from "./parentNote.vue?vue&type=template&id=de41d094&scoped=true"
import script from "./parentNote.vue?vue&type=script&lang=js"
export * from "./parentNote.vue?vue&type=script&lang=js"
import style0 from "./parentNote.vue?vue&type=style&index=0&id=de41d094&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de41d094",
  null
  
)

export default component.exports